// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.l-title[data-v-13d7c43c] {\n  font-family: 'Helvetica Bold', sans-serif;\n  font-weight: 900;\n  font-size: 18pt;\n  line-height: 14pt;\n  color: white;\n  text-transform: uppercase;\n}\n", ""]);
// Exports
module.exports = exports;
